import BillingSummaryCSVPreviewColumnsStrategy from './BillingSummaryCSVPreviewColumnsStrategy'

export default function BillingSummaryCSVPreviewTimeOnNonBillableTasksStrategy() {}

BillingSummaryCSVPreviewTimeOnNonBillableTasksStrategy.prototype = new BillingSummaryCSVPreviewColumnsStrategy();

BillingSummaryCSVPreviewTimeOnNonBillableTasksStrategy.prototype.init = function ()
{
    BillingSummaryCSVPreviewColumnsStrategy.prototype.init.call( this );
    return this;
};

BillingSummaryCSVPreviewTimeOnNonBillableTasksStrategy.prototype.getNumOfDataColumns = function ()
{
    return 4;
};

BillingSummaryCSVPreviewTimeOnNonBillableTasksStrategy.prototype.addMainHeaderRowCells = function ( mainHeaderRow )
{
    this.addCell( mainHeaderRow, this.message("report.billing_summary.overall_spent.only_nonbillible.csv") );

    this.addBillingTypeCells( mainHeaderRow, this.getNumOfDataColumns() - 1 );
};

BillingSummaryCSVPreviewTimeOnNonBillableTasksStrategy.prototype.addColumnGropingHeaderRowCells = function ( colGroupingRow )
{
    // do nothing
};




// WEBPACK FOOTER //
// ./web/js/reports/preview/csv/billingsummary/BillingSummaryCSVPreviewTimeOnNonBillableTasksStrategy.js